import { _ACTIVITIES } from "../constants";

export const SALES_FILAIRE_TOTAL_VOLUME = "Total Volume";
export const SALES_FILAIRE_TOTAL_VALUE = "Total Value";

export const SAVE_CATEGORY = "sales_filaire_volume";

export const SAVE_DATA_SALES_FILAIRE = [
  {
    activity: _ACTIVITIES.FILAIRE,
    theme: [
      { name: SALES_FILAIRE_TOTAL_VOLUME, quantity: 1 },
      { name: SALES_FILAIRE_TOTAL_VALUE, quantity: 1 },
    ],
  },
];
